import whereNextFlipCover from './images/Where_Next_Cover_2025.jpg'
import whereNextBannerImage from './images/whereNextBannerImage.jpg'
import ChicAndUniqueFlipCover from './images/Chic_&_Unique_372X480.png'
import ChicAndSecludedBannerImage from './images/Chic_&_Secluded_Banner.jpg'
import Alabama from "./images/ATI_Web_Ads_870X375_Alabama.png"
import Arkansas from "./images/ATI_Web_Ads_870X375_Arkansas.png"
import Louisiana from "./images/ATI_Web_Ads_870X375_Louisiana.png"
import Mississippi from "./images/ATI_Web_Ads_870X375_Mississippi.png"
import Missouri from "./images/ATI_Web_Ads_870X375_Missouri.png"
import WestVirginia from "./images/ATI_Web_Ads_870X375_WestVirginia.png"
import Kentucky from "./images/ATI_Web_Ads_870X375_Kentucky.png"
import Tennessee from "./images/ATI_Web_Ads_870X375_Tennessee.png"

export default [
{
    id: 1,
    title: "Where Next 2025",
    intro: "Check out ATI’s recently released version of our In-Tour magazine “Where Next” Partnering with destinations across North America, “Where Next” inspires visitors to plan their next North American journey while enjoying an ATI tour. The magazine is distributed to all ATI touring passengers, who have chosen to experience North America for their holiday.",
    hero: whereNextFlipCover,
    titleImage: whereNextBannerImage,
    link: { location: "http://images.americantours.com/files/AgentPortal/Sales%20Agent%20Portal%20Files/Where%20Next/Where_Next_Magazine_2025.pdf", link_text: "Check out Where Next!" },
    data: [
      {
        title: "Where Next 2025",
        type: "p_with_image",
        image: whereNextFlipCover,
        text: "Check out ATI’s recently released version of our In-Tour magazine “Where Next” Partnering with destinations across North America, “Where Next” inspires visitors to plan their next North American journey while enjoying an ATI tour. The magazine is distributed to all ATI touring passengers, who have chosen to experience North America for their holiday."
      },
      {
        type: "pdf",
      }
    ]
  },
  {
    id: 2,
    title: "Alabama",
    hero: Alabama,
    link: {
      "location": "/landingpages/destination/alabama.html"
    },
    data: {
      title: "Alabama Ad",
      type: "ad",
      image: Alabama
    }
  },
    {
    id: 3,
    title: "Arkansas",
    hero: Arkansas,
    link: {
      "location": "/landingpages/destination/arkansas.html"
    },
    data: {
      title: "Arkansas Ad",
      type: "ad",
      image: Arkansas
    }
  },
  {
    id: 4,
    title: "Louisiana",
    hero: Louisiana,
    link: {
      "location": "/landingpages/destination/louisiana.html"
    },
    data: {
      title: "Louisiana Ad",
      type: "ad",
      image: Louisiana
    }
  },
  {
    id: 5,
    title: "Mississippi",
    hero: Mississippi,
    link: {
      "location": "/landingpages/destination/mississippi.html"
    },
    data: {
      title: "Mississippi Ad",
      type: "ad",
      image: Mississippi
    }
  },
  {
    id: 6,
    title: "Missouri",
    hero: Missouri,
    link: {
      "location": "/landingpages/destination/missouri.html"
    },
    data: {
      title: "Missouri Ad",
      type: "ad",
      image: Missouri
    }
  },
  {
    id: 7,
    title: "WestVirginia",
    hero: WestVirginia,
    link: {
      "location": "/landingpages/destination/westvirginia.html"
    },
    data: {
      title: "WestVirginia Ad",
      type: "ad",
      image: WestVirginia
    }
  },
  {
    id: 8,
    title: "Kentucky",
    hero: Kentucky,
    link: {
      "location": "/landingpages/destination/kentucky.html"
    },
    data: {
      title: "Kentucky Ad",
      type: "ad",
      image: Kentucky
    }
  },
  {
    id: 9,
    title: "Tennessee",
    hero: Tennessee,
    link: {
      "location": "/landingpages/destination/tennessee.html"
    },
    data: {
      title: "Tennessee Ad",
      type: "ad",
      image: Tennessee
    }
  },
  {
    id: 10,
    title: "Chic & Unique",
    intro: "ATI presents our new Chic & Unique hotel collection featuring our favorite properties in bustling urban and scenic rural settings across North America.",
    hero: ChicAndUniqueFlipCover,
    titleImage: ChicAndSecludedBannerImage,
    link: { location: "http://images.americantours.com/files/AgentPortal/Sales%20Agent%20Portal%20Files/Where%20Next/Chic_&_Unique_2024_112524.pdf", link_text: "Click Here For Brochure" },
    data: [
      {
        title: "Our favorite Chic & Unique properties are based in suburban, rural, or resort destinations amidst natural surroundings that are breaming with outdoor experiences.",
        type: "p_with_image",
        image: ChicAndUniqueFlipCover,
        text: "ATI's Chic & Unique collection features properties that either embody the unique cultural features of a destination, present an element of history or are iconic in their own right, provide a level of luxury that is unparalleled, offer an immersive experience to their guest that takes them away from the pressures of the modern world, or some combination thereof. Learn more about these fabulous accommodations today!"
      },
      {
        type: "pdf",
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/whats-new-content.js